module.exports = __webpack_public_path__ + "static/media/Paqtana-Portrait-Logo.09a3c51c.svg";